import { NCWSendAssetCardSkeleton } from '../../../ui';

import * as S from './styled';

/**
 * The card skeletons are displayed during the initial loading or refetching
 */
export const CardSkeletons = () =>
	[0, 1, 2, 3, 4].map(index => (
		<S.CardContainer $show key={index}>
			<NCWSendAssetCardSkeleton />
		</S.CardContainer>
	));
